import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { FieldDataProvider } from "../../data-provider/field.dp";
import { Campaign } from "../../models/campaign.model";
import { Feature } from "../../models/feature.model";
import { PermissionCheck } from "../../shared/permission";

let MockupPaneComponent = {
    selector: "vcMockupPane",
    templateUrl: "/angular/components/customize/mockup-pane.component.html",
    restrict: "EA",
    replace: true,
    bindings: {
        showPreview: "=",
        tab: "=",
    },
    controller: class MockupPaneController {
        // * bindings for typescript compiler *
        public showPreview: any;
        public tab: string;
        // ************************************

        private isLeaderView: boolean;
        public preview;
        public activeCampaign: Campaign;
        public permissions;
        public feature: Feature;

        private readonly $scope: any;
        private readonly permissionProvider: PermissionCheck;
        public fieldDataProvider: FieldDataProvider;

        constructor(
            $scope: any,
            __app_type: string,
            PermissionCheck: PermissionCheck,
            FieldDataProvider: FieldDataProvider,
            CampaignDataProvider: CampaignDataProvider
        ) {
            this.$scope = $scope;
            this.preview = {};
            this.permissionProvider = PermissionCheck;
            this.fieldDataProvider = FieldDataProvider;
            this.activeCampaign = CampaignDataProvider.getActiveCampaign();
            this.isLeaderView = __app_type == "LEADER";

            let localStorage = this.activeCampaign.getLocalStorage();
            this.preview.system =
                localStorage && localStorage.customizePreviewSystem
                    ? localStorage.customizePreviewSystem
                    : "android";

            this.permissions = PermissionCheck.levels;
            this.feature = null;

            this.permissionProvider
                .getFeaturePermissions()
                .then(() => this.watchReception());
        }

        watchReception() {
            this.$scope.$watch(
                () => this.permissionProvider.featurePermissions.RECEPTION,
                () => this.updateReceptionFeature(),
                true
            );
        }

        saveSystemChoice(system) {
            this.activeCampaign.localInfo.customizePreviewSystem = system;
            this.activeCampaign.saveLocalStorage();
        }

        updateReceptionFeature() {
            this.permissionProvider
                .getFeature("RECEPTION")
                .then((feature) => (this.feature = feature));
        }
    },
};

angular
    .module("customize")
    .component(MockupPaneComponent.selector, MockupPaneComponent);
